import axios from 'axios';

import BaseService from "./BaseService";
import LogUtils from "../utils/LogUtils";
import MsgUtils from "../utils/MsgUtils";
import settings from "../settings/settings";

class DenounceStatusService extends BaseService {

   constructor() {
      super();
      this.TAG = "DenounceStatusService";
      this.DENOUNCE_STATUS = {
         OPENED: {
            name: "opened",
            prettyName: "Não iniciado"
         },
         IN_PROGRESS: {
            name: "in-progress",
            prettyName: "Em progresso"
         },
         CLOSED: {
            name: "closed",
            prettyName: "Finalizado"
         }
      }
      this.DENOUNCE_STATUS_NAME_OBJS = {};

      this.logUtils = new LogUtils();
      this.msgUtils = new MsgUtils();

      this.setDenounceTypes();
   }

   setDenounceTypes() {
      const txts = this.msgUtils.getTxts();

      this.DENOUNCE_STATUS.OPENED.langName = txts.DENOUNCE_STATUS.OPENED;
      this.DENOUNCE_STATUS.IN_PROGRESS.langName = txts.DENOUNCE_STATUS.IN_PROGRESS;
      this.DENOUNCE_STATUS.CLOSED.langName = txts.DENOUNCE_STATUS.CLOSED;

      this.DENOUNCE_STATUS_NAME_OBJS[this.DENOUNCE_STATUS.OPENED.name] = this.DENOUNCE_STATUS.OPENED;
      this.DENOUNCE_STATUS_NAME_OBJS[this.DENOUNCE_STATUS.IN_PROGRESS.name] = this.DENOUNCE_STATUS.IN_PROGRESS;
      this.DENOUNCE_STATUS_NAME_OBJS[this.DENOUNCE_STATUS.CLOSED.name] = this.DENOUNCE_STATUS.CLOSED;
   }

   async getDenounceStatus() {
      let denounceStatus = {};

      try {
         const response = this.getResponse(await axios(this.getBasicHttpRequest(
            this.HTTP_METHODS.GET,
            `${settings.MANAGEMENT_SERVICE_URL}/denounce-status`,
            this.getDefaultHeaders(true)
         )));

         if (response.status !== 1) {
            return {
               status: 0,
               msg: "Não foi possível retornar a lista de status da denúncia."
            };
         }

         if (!response.data) {
            return {
               status: -1,
               msg: "Não foi possível retornar a lista de status da denúncia."
            };
         }

         denounceStatus = response.data;

      } catch (err) {
         this.logUtils.logErrorMsg(this.TAG, "Unabled to getDenounceStatus", err);

         return {
            status: -2,
            msg: this.parseError(err)
         };
      }

      return {
         status: 1,
         msg: "A lista de status da denúncia foi retornada com sucesso.",
         data: denounceStatus
      };
   }

}

export default DenounceStatusService;